<template>
  <div class="adminPayments">
    <Navigation :showPromoterNav="true"></Navigation>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 p-t-6 m-t-4" v-if="!loading && transactions.length === 0" >
          There are no transactions yet
        </div>
        <div class="col-md-12 p-t-6 m-t-4">
          <table class="table" v-if="loaded">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>type</th>
                <th>Booking code</th>
                <th>Processing At</th>
                <th>Processed</th>
                <th>Value</th>
                <th>Fee</th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="transaction in transactions">
              <td>{{transaction.from}}</td>
              <td>{{transaction.to}}</td>
              <td>{{transaction.transaction_type}}</td>
              <td>{{transaction.booking_code}}</td>
              <td>{{transaction.processing_at}}</td>
              <td>
                <span v-if="executed">yes</span>
                <span v-if="!executed">no</span>
              </td>
              <td>{{transaction.value}} €</td>
              <td>{{transaction.fee}} €</td>
            </tr>
          </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>

</template>


<script>
import { mapState, mapActions } from 'vuex';
import Navigation from '../Admin/Navigation/Navigation';

export default {
  name: 'AdminPayments',
  components: {
    Navigation,
  },
  computed: {
    ...mapState({
      loading: state => state.adminPayments.loading,
      loaded: state => state.adminPayments.loaded,
      transactions: state => state.adminPayments.data,
    }),
  },
  methods: {
    ...mapActions({
      getPayments: 'adminPayments/get',
    }),
  },
  mounted() {
    this.getPayments();
  },
};

</script>


<style lang="scss" scoped>
.adminPayments {
  min-height: 100vh;
}

</style>



// WEBPACK FOOTER //
// AdminPayments.vue?add24c02